import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustomerService } from 'app/shared/services/customer.service';
import { FileUploadComponent } from '../../../file-upload/file-upload.component';
import { FileUploadService } from 'app/shared/services/file-upload.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { AuthService } from 'app/shared/services/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import { NbThemeService } from '@nebular/theme';


@Component({
  selector: 'app-add-customer',
  templateUrl: './add-customer.component.html',
  styleUrls: ['./add-customer.component.css']
})
export class AddCustomerComponent implements OnInit {

  isDark: boolean = false;
  isShowAttachBtn: boolean=false;
  addCustomerForm: FormGroup;
  isSaveBtnDisabled : boolean= false;
  isValidFormData: boolean = true;
  showProcessingIndicator =false;

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };

  
  validationMessages = {
    'cusId': { 'required': 'Customer Id is required' },
    'cusName': { 'required': 'Customer name is required' },
    'address': { 'required': 'Address is required' },
    'phone': { 'required': 'Phone Number is required' },
    'email': {'email': 'Email must be a valid email address'},   
  };

  formErrors = {
    'cusId': "",
    'cusName': "",
    'address': "",
    'phone': "",
    'email': "",
  };




    constructor(private fb: FormBuilder,
                private customerService: CustomerService,
                private fileUploadService:FileUploadService,
                private authService: AuthService,
                private toastr: ToastrService,
                private router : Router, 
                private themeService: NbThemeService,
                private dialogService: DialogService
              ) {}
              
               

              

  ngOnInit() {
 
    this.addCustomerForm = this.fb.group({
      id : [null],
      cusId : ['', Validators.required],
      cusName : ['', Validators.required],
      address : ['', Validators.required],
      shippingAddress: [''],
      vatNo : [''],
      svatNo : [''],
      phone : ['', Validators.required],
      fax : [''],
      email : ['', [Validators.email]],
      status : [false],
      createdBy : [''],

    });

  
   this.addCustomerForm.valueChanges.subscribe((data) => {
    this.logValidationErrors(this.addCustomerForm);
  });


    this.getDataTableRowData();
   this.getControlPermissions();
    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });

  } /////// end onInit

  
  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='CM'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }

  attachFileButtonClick(){
    this.fileUploadService.refNo = this.addCustomerForm.value.cusId;
     const dialogConfig = new MatDialogConfig();
     dialogConfig.disableClose = true;
     dialogConfig.autoFocus = true;
     dialogConfig.width = "75%";
     this.dialogService.openDialog(FileUploadComponent,dialogConfig);
        
    }

  newButtonClick(): void {
    this.isShowAttachBtn=false; 
    this.isSaveBtnDisabled = false;
    this.addCustomerForm.reset();
    this.enableForm();
    this.getMaxId();
   }

   
  
   getMaxId(){
    var customerId = 0;
    var sCustomerId : String;
  
    this.customerService.getMaxId()
    .subscribe(
      (res) => {
                  customerId = Number(res[0].MaxId) + 1;
                  sCustomerId = customerId.toString().padStart(6,'0');
                  this.addCustomerForm.patchValue({
                    cusId : "CUS" + sCustomerId
                  });
                  

                },        
      (err) =>  {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                }, 
      )



   }

  saveButtonClick(): void {
  
    this.logValidationErrors(this.addCustomerForm,true);
    const formData = this.mapFormValuesToCustomerModel();  

          if(this.isFilledFromFields()){
            
              if(!this.addCustomerForm.value.id){
                this.showProcessingIndicator = true;
                this.customerService.addCustomer(formData)
                .subscribe(
                  (res) => {

                              if(res.success === 0){
                                this.addCustomerForm.patchValue({
                                cusId : res.autoId
                                });
                              this.saveButtonClick();
                              this.showProcessingIndicator = false; 
                              
                              }else if(res.success === 1){
                                this.toastr.success('Record created successfully','Success'); 
                                this.showProcessingIndicator = false; 
                                this.isShowAttachBtn = true;
                                this.newButtonClick()
                             }   

                            },        
                  (err) =>  {
                              this.toastr.error('Failed to create record','Failure');                            
                              this.showProcessingIndicator = false;
                              if(err instanceof HttpErrorResponse){                 
                                if(err.status == 401){
                                  this.router.navigate(['/login']);
                                }
                              }
                              console.log(err);
                            }, 
                  )
  
                   

            }else{
            this.dialogService.openConfirmDialog('Are you sure you want to update this record?')
            .afterClosed().subscribe(res =>{
              if(res){
              this.showProcessingIndicator = true;
              this.customerService.updateCustomer(formData)
            .subscribe(
              (res) => {
                          this.toastr.success('Record updated successfully','Success');    
                          this.showProcessingIndicator = false;  
                          this.newButtonClick();
                        },        
              (err) =>  {
                          this.toastr.error('Failed to update record','Failure');
                          this.showProcessingIndicator = false;
                          if(err instanceof HttpErrorResponse){                 
                            if(err.status == 401){
                              this.router.navigate(['/login']);
                            }
                          }
                          console.log(err);
                        }, 
                      )

          }else{
            this.showProcessingIndicator = false;
          }
            })

        }

      }
      else{
        this.toastr.warning('Required Fields cannot be empty or invalid.','Error Message');
        this.showProcessingIndicator = false;
        
      } 
                       
         
   }

  

   enableForm():void{
    Object.keys(this.addCustomerForm.controls).forEach(key => {
      this.addCustomerForm.controls[key].enable();
      //console.log(key)
    });
  }


  disableForm():void{
    Object.keys(this.addCustomerForm.controls).forEach(key => {
      this.addCustomerForm.controls[key].disable();   
    });
  }


  
  logValidationErrors(group: FormGroup = this.addCustomerForm,isDirty :boolean=false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if(isDirty)
      {
        this.enableForm();
        this.addCustomerForm.controls[key].markAsTouched();
      }
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } 
    });
  }


  isFilledFromFields() : boolean {
    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
          return false;
        }
        return true;
}



  mapFormValuesToCustomerModel(){
    let status;
    if(this.addCustomerForm.value.status){
      status='Deactivated';    
    }
    else{
      status='Active';
    }  
    let formData ={
      ...this.addCustomerForm.value,
      status : status,
      createdBy : this.authService.getUserLoggedIn(),
    }

    return formData;
    
  }

activeStatus = false;
viewCustomer(customer){
  if(customer.Status=='Active'){
    this.activeStatus = false;
  }else{
    this.activeStatus = true;
  }
 
  this.addCustomerForm.patchValue({
    id : customer.Id,
    cusId : customer.CusId,
    cusName :customer.CusName,
    address : customer.Address,
    shippingAddress: customer.ShippingAddress,
    vatNo : customer.VATNo,
    svatNo : customer.SVATNo,
    phone : customer.Phone,
    fax : customer.Fax,
    email : customer.Email,
    status : this.activeStatus,    
   
  })

  this.isShowAttachBtn = true; 
}

getDataTableRowData(){
  var data  = this.customerService.dataRow;
  if(data){
    this.viewCustomer(data);
  }
  else{
    this.newButtonClick()
  }
  
                       
}




}//end class
